export default "__VITE_ASSET__BOqohrLv__"